<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Payroll</span>
      <h1 class="hris-page-title">My Loan Applications</h1>
      <p class="hris-page-subtitle">Apply for loans and track deduction history.</p>
    </div>

    <div class="hris-toolbar">
      <q-btn unelevated class="hris-q-primary" label="Apply for Loan" @click="applyDialog = true" ></q-btn>
      <div class="hris-toolbar-spacer"></div>
      <q-input outlined dense color="green" v-model="fromDay" mask="date" label="From" style="width: 160px;">
        <template v-slot:append>
          <i class="far fa-calendar-alt cursor-pointer">
            <q-popup-proxy transition-show="scale" transition-hide="scale">
              <q-date v-model="fromDay">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Close" flat class="hris-q-ghost" ></q-btn>
                </div>
              </q-date>
            </q-popup-proxy>
          </i>
        </template>
      </q-input>

      <q-input outlined dense color="green" v-model="toDay" mask="date" label="To" style="width: 160px;">
        <template v-slot:append>
          <i class="far fa-calendar-alt cursor-pointer">
            <q-popup-proxy transition-show="scale" transition-hide="scale">
              <q-date v-model="toDay">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Close" flat class="hris-q-ghost" />
                </div>
              </q-date>
            </q-popup-proxy>
          </i>
        </template>
      </q-input>
      <q-btn unelevated class="hris-q-outline" label="Filter Data" @click="getLoanList" />
    </div>

    <div class="hris-panel">
      <q-table
        flat
        :dense="$q.screen.lt.md"
        :grid="$q.screen.xs"
        title="My Loan Applications"
        :data="generatedData"
        :columns="columns"
        row-key="id"
        separator="cell"
        :pagination.sync="pagination"
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="loanType" :props="props">{{ props.row.loanType }}</q-td>
            <q-td key="loanAmount" :props="props">{{ props.row.loanAmount }}</q-td>
            <q-td key="loadDate" :props="props">{{ props.row.loadDate }}</q-td>
            <q-td key="startDate" :props="props">{{ props.row.startDate }}</q-td>
            <q-td key="endDate" :props="props">{{ props.row.endDate }}</q-td>
            <q-td key="monthlyDeduction" :props="props">{{ props.row.monthlyDeduction }}</q-td>
            <q-td key="loanBalance" :props="props">{{ props.row.loanBalance }}</q-td>
            <q-td key="status" :props="props">
              <span
                class="hris-badge"
                :class="(props.row.status == 'APPROVED') ? 'hris-badge-success' : (props.row.status == 'PENDING') ? 'hris-badge-warning' : 'hris-badge-danger'"
              >{{ props.row.status }}</span>
            </q-td>
            <q-td>
              <q-btn flat round dense class="hris-q-ghost" icon="fas fa-calendar-alt" @click="showHistory(props.row.id)">
                <q-tooltip>Deduction History</q-tooltip>
              </q-btn>
            </q-td>
          </q-tr>
        </template>
        <template v-slot:no-data="">
          <div class="hris-empty full-width">
            No loan applications found for the selected date range.
          </div>
        </template>
      </q-table>
    </div>

    <LoanApplicationDialog
      v-model="applyDialog"
      :loanTypeOptions="loanTypeOptions"
      @submit="onSubmit"
    />

    <DeductionHistoryDialog
      v-model="deductHistory"
      :deductionHistory="deductionHistory"
      :totaldeductionHistory="totaldeductionHistory"
    />
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';
import LoanApplicationDialog from './LoanApplicationDialog.vue';
import DeductionHistoryDialog from './DeductionHistoryDialog.vue';

export default {
  mixins: [mixins],
  components: { LoanApplicationDialog, DeductionHistoryDialog },
  data() {
    return {
      fromDay: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
      toDay: new Date().toISOString().slice(0, 10).replace("-", "/").replace("-", "/"),
      deductHistory: false,
      applyDialog: false,
      pagination: { rowsPerPage: 30 },
      loanTypeOptions: [],
      generatedData: [],
      columns: [
        { name: 'loanType', align: 'center', label: 'Loan Type', field: 'loanType', sortable: true },
        { name: 'loanAmount', align: 'center', label: 'Requested Amount', field: 'loanAmount', sortable: true },
        { name: 'loadDate', align: 'center', label: 'Date Applied', field: 'loadDate', sortable: true },
        { name: 'startDate', align: 'center', label: 'Start Date', field: 'startDate', sortable: true },
        { name: 'endDate', align: 'center', label: 'End Date', field: 'endDate', sortable: true },
        { name: 'monthlyDeduction', align: 'center', label: 'Monthly Deduction', field: 'monthlyDeduction', sortable: true },
        { name: 'loanBalance', align: 'center', label: 'Balance', field: 'loanBalance', sortable: true },
        { name: 'status', align: 'center', label: 'Status', field: 'status', sortable: true },
        { align: 'center', label: 'Action', sortable: false },
      ],
      deductionHistory: [],
      totaldeductionHistory: 0,
    }
  },
  created() {
    this.getLoanList()
    this.getLoanTypeList()
  },
  methods: {
    getLoanList() {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get(`/payroll/my-loans`, { params: { fromDay: this.fromDay, toDay: this.toDay } })
        .then((res) => { this.generatedData = res.data.data });
    },
    getLoanTypeList() {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).get(`/payroll/loan/type/list`)
        .then((res) => { this.loanTypeOptions = res.data.types });
    },
    onSubmit(formData) {
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).post(`/payroll/apply-loan`, formData)
        .then(() => {
          this.$q.notify({ color: 'green', message: 'Application submitted.' });
          this.applyDialog = false;
          this.getLoanList();
        });
    },
    showHistory(id) {
      this.deductHistory = true
      axios.create({
        baseURL: this.apiUrl,
        headers: { 'Authorization': `Bearer ${this.token}` }
      }).post(`/payroll/loan/history`, { id: id })
        .then((res) => {
          this.totaldeductionHistory = res.data.total
          this.deductionHistory = res.data.data
        });
    }
  }
}
</script>
